import { createSlice } from '@reduxjs/toolkit';
import {
  PackagesModel,
  PaymentResponse,
} from 'pages/Home/Packages/Packages.types';
import {
  getPackages,
  getPackagesDetails,
  getUserPackages,
  purchasePackages,
  cancelPayment,
} from 'services/auth/packages.service';

interface packagesSliceType {
  loading: boolean;
  packages: PackagesModel[];
  userPackages: any;
  packageDetails: PaymentResponse | null;
}

const initialState = {
  loading: false,
  packages: [],
  userPackages: [],
  packageDetails: null,
} as packagesSliceType;

const packagesSlice = createSlice({
  name: 'packages',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    // CARDS
    builder.addCase(getPackages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPackages.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.packages = payload;
    });
    builder.addCase(getPackages.rejected, (state) => {
      state.loading = false;
    });

    // PACKAGES
    builder.addCase(getUserPackages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserPackages.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.userPackages = payload;
    });
    builder.addCase(getUserPackages.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(purchasePackages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(purchasePackages.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.packages = payload;
    });
    builder.addCase(purchasePackages.rejected, (state, { payload }) => {
      console.log(payload);
      state.loading = false;
    });

    // PACKAGE DETAILS
    builder.addCase(getPackagesDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPackagesDetails.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.packageDetails = payload;
    });
    builder.addCase(getPackagesDetails.rejected, (state) => {
      state.loading = false;
    });

    // CANCEL PAYMENT
    builder.addCase(cancelPayment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(cancelPayment.fulfilled, (state, { payload }) => {
      state.loading = false;

      if (state.packageDetails && state.packageDetails.id === payload) {
        state.packageDetails.status = 'canceled';
      }
    });
    builder.addCase(cancelPayment.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default packagesSlice.reducer;
